// import { useQuery } from "@tanstack/react-query";
// import { fetch3 } from "../commonApis/commonApis";
// import { useSelector } from "react-redux";
// const url = process.env.REACT_APP_BASE_URL;

// export const useFetchOrderSummary = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["orderSummary", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/order-summary?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchOFDOrderSummary = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["ofdOrderSummary", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/ofd-summary?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchFleetSummary = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["fleetSummary", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/fleet-summary`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchCodWalletAnalytics = (range: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["codWalletAnalytics", profile?.id, range],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/cod-wallet-analytics?filter=${range}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchRecentCODOrders = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["recentCODOrders", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/recent-cod-orders`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchSaleOverview = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["saleOverview", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/sale-overview?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetch3plForwardOrders = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["3plForwardOrders", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/3pl-channels-forward-orders?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchTop10DriverPerformance = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["driverPerformance", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/driver-performance?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchTop10ClientPerformance = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["clientPerformance", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/client-performance?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchOrdersGraph = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["orderGraph", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/order-graph`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// // Driver list api by Iram

// export const useFetchDriverList = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["driverList", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/driver-performance?type=Today&limit=20`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// }

import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_BASE_URL;

export type SummaryPeriod =
  | "Today"
  | "Yesterday"
  | "Last 7 Days"
  | "Last 30 Days"
  | "All Time";

export const useFetchOrderSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: string;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/order-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

// Fetch LM / FM / Total order counts
export const useFetchOrderTypeSummary = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderTypeSummary", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/dashboard/order-type-summary`,
        "get",
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useFetchOrderSummaryLMFM = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderSummaryLMFM", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/order-summary-lmfm?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

export const useFetchOFDOrderSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["ofdOrderSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/ofd-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

export const useFetchFleetSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["fleetSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/fleet-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

export const useFetchCodWalletAnalytics = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["codWalletAnalytics", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/cod-wallet-analytics?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRecentCODOrders = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["recentCODOrders", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/recent-cod-orders`, "get");
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchSaleOverview = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["saleOverview", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const res = await fetch3(
        `${url}/api/dashboard/sale-overview?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetch3plForwardOrders = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "3plForwardOrders",
      profile?.id,
      type,
      startDate,
      endDate,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/3pl-channels-forward-orders?${params.toString()}`,
        "get"
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useFetchTop10DriverPerformance = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "driverPerformance",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));
      const res = await fetch3(
        `${url}/api/dashboard/driver-performance?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchTop10ClientPerformance = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["clientPerformance", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const res = await fetch3(
        `${url}/api/dashboard/client-performance?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchOrdersGraph = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderGraph", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/order-graph`, "get");
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchDriverList = (summaryType: string, limit = 20) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["driverList", profile?.id, summaryType, limit],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/dashboard/driver-performance?type=${summaryType}&limit=${limit}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchDriverCODPerformance = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "driverCODPerformance",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/driver-cod-performance?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
  });
};

// Merchant COD order ghaph api
export const useFetchMerchantCODGraph = ({
  type,
  startDate,
  endDate,
  limit = 15,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "merchantCODGraph",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/merchant-cod-graph?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
  });
};

// Saudi Province map 

export interface SaudiProvinceOrders {
  province: string;
  totalOrders: number;
}

export const useFetchOrdersBySaudiProvince = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery<SaudiProvinceOrders[]>({
    queryKey: [
      "ordersBySaudiProvince",
      profile?.id,
      type,
      startDate,
      endDate,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/orders-by-saudi-province?${params.toString()}`,
        "get"
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

